import { FC } from "react";
import { useTranslation } from "react-i18next";
import ErrorIcon from "@mui/icons-material/Error";
import { Box, Typography, Button } from "@mui/material";
interface EmptyStateProps {
  title: string;
  onReset: () => void;
}
export const EmptyState: FC<EmptyStateProps> = ({
  title,
  onReset
}) => {
  const {
    t
  } = useTranslation();
  return <Box sx={{
    textAlign: "center"
  }} data-sentry-element="Box" data-sentry-component="EmptyState" data-sentry-source-file="EmptyState.tsx">
      <ErrorIcon fontSize="large" sx={{
      mb: 3
    }} color="primary" data-sentry-element="ErrorIcon" data-sentry-source-file="EmptyState.tsx" />
      <Typography variant="h5" sx={{
      mb: 0.5
    }} data-sentry-element="Typography" data-sentry-source-file="EmptyState.tsx">
        {title}
      </Typography>
      <Typography color="text.secondary" sx={{
      mb: 3
    }} data-sentry-element="Typography" data-sentry-source-file="EmptyState.tsx">
        {t("reports.emptyStateHint")}
      </Typography>
      <Button variant="contained" onClick={onReset} data-sentry-element="Button" data-sentry-source-file="EmptyState.tsx">
        {t("shell.resetFilters")}
      </Button>
    </Box>;
};